// trigger filter on home page
(function () {
    const heroForm = document.getElementById('hero-form');
    if (heroForm) {
        const countrySelect = document.getElementById('country');
        const destinationSelect = document.getElementById('destination');
        const categorySelect = document.getElementById('category');

        // Cache for country regions and categories to avoid redundant API calls
        const countryRegionsCache = new Map();
        const countryCategoriesCache = new Map();

        /**
         * Fetches regions for a country from cache or API
         * @param {string} countryId - The ID of the country
         * @returns {Promise<Array>} Array of region objects
         */
        async function fetchCountryRegions(countryId) {
            if (countryRegionsCache.has(countryId)) {
                return countryRegionsCache.get(countryId);
            }
            const result = await axios.get(`/api/countries/${countryId}/regions`);
            countryRegionsCache.set(countryId, result.data);
            return result.data;
        }

        /**
         * Fetches categories for a country from cache or API
         * @param {string} countryId - The ID of the country
         * @returns {Promise<Array>} Array of category objects
         */
        async function fetchCountryCategories(countryId) {
            if (countryCategoriesCache.has(countryId)) {
                return countryCategoriesCache.get(countryId);
            }
            const result = await axios.get(`/api/countries/${countryId}/categories`);
            countryCategoriesCache.set(countryId, result.data);
            return result.data;
        }

        /**
         * Country selection handler - implements hierarchical filtering:
         * When a country is selected, load its regions and available categories
         * This creates a cascading dropdown effect: Country → Region → Category
         */
        countrySelect.addEventListener('change', async (ev) => {
            const countryId = countrySelect.options[ev.target.selectedIndex].dataset.id;

            // Reset dependent dropdowns when country changes
            // Clear and disable region and category dropdowns until new data is loaded
            destinationSelect.options.length = 1; // Keep only the placeholder option
            destinationSelect.disabled = true;
            categorySelect.options.length = 1;
            categorySelect.disabled = true;

            if (countryId) {
                // Load all regions that belong to the selected country
                // This populates the region/destination dropdown with country-specific options
                const regions = await fetchCountryRegions(countryId);
                regions.forEach((region) => {
                    destinationSelect.options.add(createOption(region));
                });
                destinationSelect.disabled = false;

                // Load all categories that have services in any region of the selected country
                // This shows categories available across the entire country (union of all regions)
                const categories = await fetchCountryCategories(countryId);
                categories.forEach((category) => {
                    categorySelect.options.add(createOption(category));
                });
                categorySelect.disabled = false;
            }
        });

        /**
         * Region selection handler - further filters categories
         * When a region is selected, filter categories to only those available in that specific region
         * This provides more precise filtering than country-level categories
         */
        destinationSelect.addEventListener('change', async (ev) => {
            const regionId = destinationSelect.options[ev.target.selectedIndex].dataset.id;

            // Reset category dropdown when region changes
            categorySelect.options.length = 1; // Keep only the placeholder option
            categorySelect.disabled = true;

            if (regionId) {
                // Load categories that have services in the selected region
                // This is more restrictive than country-level categories
                const result = await axios.get(`/api/regions/${regionId}/categories`);
                result.data.forEach((category) => {
                    categorySelect.options.add(createOption(category));
                });
                categorySelect.disabled = false; // Enable after categories are loaded
            }
        });

        heroForm.addEventListener('submit', function (event) {
            event.preventDefault();
            const selectedCountry = document.getElementById('country').value;
            const selectedCountryId = countrySelect.options[countrySelect.selectedIndex].dataset.id;
            const selectedDestination = document.getElementById('destination').value;
            const selectedCategory = document.getElementById('category').value;

            dataLayer.push({
                event: 'searchBarSubmit',
                country: selectedCountry,
                location: selectedDestination,
                experienceType: selectedCategory ? selectedCategory : 'not set',
            });

            /**
             * Determine navigation path based on user selections
             * Priority: Region > Country > Homepage
             * If a region is selected, navigate to that region's page
             * If only a country is selected, navigate to country page with country filter in query string
             * If nothing is selected, stay on homepage
             */
            let path;
            let queryParams = '';
            if (selectedDestination) {
                // Region selected - navigate to region page (traditional behavior)
                // URL format: /{lang}/{region-slug}/{category-slug?}
                path = window.lang + '/' + selectedDestination + (selectedCategory ? '/' + selectedCategory : '');
            } else if (selectedCountry) {
                // Only country selected (no specific region) - navigate to country page
                // URL format: /{lang}/{country-slug}/{category-slug?}?country={country-id}
                path = window.lang + '/' + selectedCountry + (selectedCategory ? '/' + selectedCategory : '');
                // Add country ID as query parameter so the backend can pre-populate filters
                // This allows the service listing page to filter by country when loaded
                queryParams = '?country=' + selectedCountryId;
            } else {
                // No selection - stay on homepage
                path = window.lang + '/';
            }

            window.location = path + queryParams;
        });
    }

    function createOption(category) {
        const option = document.createElement('option');
        option.value = category.slug;
        option.dataset.id = category.id;
        option.text = category.name.trim();
        return option;
    }
})();


// home page - categories & testimonials
const customCarousels = document.getElementsByName('custom-carousel');
if (customCarousels) {
    customCarousels.forEach((carousel) => {
        document.addEventListener('DOMContentLoaded', function () {
            import('@splidejs/splide').then((Splide) => {
                new Splide.default(carousel, {
                    type: 'loop',
                    pagination: false,
                    perPage: 4,
                    perMove: 1,
                    autoplay: 'play',
                    arrowPath:
                        'M30.1708 18.6167C30.1795 18.6248 30.1881 18.633 30.1967 18.6411C31.2678 19.6677 31.2678 21.3323 30.1967 22.3589L14.6824 37.23C13.6114 38.2567 11.8748 38.2567 10.8038 37.23C9.73277 36.2034 9.73277 34.5389 10.8038 33.5123L24.3785 20.5003L10.8033 7.48767C9.73224 6.4611 9.73224 4.79676 10.8033 3.76993C11.8743 2.74336 13.6108 2.74336 14.6819 3.76993L30.1708 18.6167Z',
                    classes: {
                        arrows: 'splide-custom-arrow',
                    },
                    breakpoints: {
                        1280: {
                            perPage: 3,
                        },
                        1024: {
                            perPage: 2,
                        },
                        640: {
                            perPage: 1,
                        },
                    },
                }).mount();
            });
        });
    });
}

if (document.getElementById('testimonials-carousel')) {
    document.addEventListener('DOMContentLoaded', function () {
        import('@splidejs/splide').then((Splide) => {
            new Splide.default('#testimonials-carousel', {
                type: 'loop',
                autoplay: true,
                interval: 9000,
            }).mount();
        });
    });
}

// newsletter form
(function () {
    const newsletterForm = document.getElementById('newsletterForm');
    if (newsletterForm) {
        newsletterForm.addEventListener('submit', function (e) {
            e.preventDefault();
            const email = this.elements['email'].value;
            const recaptcha = this.elements['recaptcha'].value;
            const newsletterMessage = document.querySelector('.newsletter-message');
            newsletterMessage.style.display = 'none';
            newsletterMessage.classList.remove('error');
            axios
                .post('/api/subscriptions/general', {
                    email,
                    recaptcha,
                })
                .then((response) => {
                    dataLayer.push({
                        event: 'newsletterConfirmed',
                    });
                    newsletterMessage.innerText = newsletterMessage.dataset.success;
                })
                .catch((err) => {
                    const { data } = err.response;
                    newsletterMessage.innerText = data?.message ? data.message : newsletterMessage.dataset.error;
                    newsletterMessage.classList.add('error');
                })
                .finally(() => (newsletterMessage.style.display = 'block'));
        });
    }
})();
